
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 33"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.175 7.219L10.8 16.68a.508.508 0 00.118.77.542.542 0 00.287.08h3.719v8.25l8.372-9.462a.508.508 0 00-.118-.769.543.543 0 00-.286-.081h-3.718v-8.25zM7.438 6.394a11.565 11.565 0 00-4.655 4.181 11.1 11.1 0 00-1.72 5.925 11.1 11.1 0 001.72 5.925 11.565 11.565 0 004.655 4.181","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.563 9.977a7.373 7.373 0 00-3.098 2.664 7.066 7.066 0 00-1.152 3.86c0 1.365.4 2.704 1.152 3.858a7.373 7.373 0 003.098 2.665M26.563 6.394c1.919.95 3.53 2.397 4.655 4.18a11.099 11.099 0 011.72 5.926c0 2.091-.595 4.142-1.72 5.925a11.564 11.564 0 01-4.655 4.181","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M24.438 9.977a7.373 7.373 0 013.098 2.664 7.066 7.066 0 011.151 3.86c0 1.365-.4 2.704-1.152 3.858a7.373 7.373 0 01-3.098 2.665","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    